export type InterviewScoreBand = "strong" | "improving" | "needs-work";

export interface InterviewScoreMeta {
  label: string;
  band: InterviewScoreBand;
}

export const getInterviewScoreMeta = (percent: number): InterviewScoreMeta => {
  const safe = Number.isFinite(percent) ? percent : 0;
  if (safe >= 70) {
    return { label: "Strong Performance", band: "strong" };
  }
  if (safe >= 50) {
    return { label: "Good – Improving", band: "improving" };
  }
  return { label: "Needs Work", band: "needs-work" };
};
